export const ACCOUNT_CODES = ['50053', '50055', '50057', '50058', '50076', '50079'];
